
import React, { useState, useEffect } from 'react';
// import './CountDown.css'; // Import the CSS file

const EmployeeCountDown = () => {
  
  // Employee Count down
  const counters = [
    { label: "Employees", start: 300, end: 250 },
    { label: "Clients", start: 100, end: 60 },
    { label: "Years of Experience", start: 25, end: 20 },
  ];

  const [counts, setCounts] = useState(
    counters.map((counter) => counter.start)
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setCounts((prevCounts) =>
        prevCounts.map((count, index) =>
          count > counters[index].end ? count - 1 : count
        )
      );
    }, 50); // Speed of countdown

    return () => clearInterval(interval);
  }, []);

return (
    <div className="d-flex justify-content-center gap-10">
        {counters.map((counter, index) => (
            <div key={index} className="p-3 text-center bg-gray countdown-box">
            <h3 className="text-primary">{counts[index]}</h3>
            <p className="mb-0">{counter.label}</p>
            </div>
        ))}
    </div>
    );
};

export default EmployeeCountDown;